// Lead Generation System — STAFF manager feedback (coaching notes) API client.
// Thin typed wrappers over `api/lead-generators/{id}/feedback` (reads gate on
// LeadGen.View; posting on LeadGen.Manage). Standalone from the roster client
// (leadGenerators.ts) — the manager → generator coaching surface.

import { api } from "@/api/client";

/** A coaching note, projected with the author's display name + the generator's
 *  read status. Mirrors LeadGenFeedbackNoteDto (Core/DTOs/LeadGen). */
export interface LeadGenFeedbackNoteDto {
  id: string;
  leadGeneratorId: string;
  authorUserId: string;
  authorName: string;
  body: string;
  category?: string | null;
  weekOf?: string | null;
  isRead: boolean;
  acknowledgedAtUtc?: string | null;
  createdAt: string;
}

export interface PostLeadGenFeedbackRequest {
  body: string;
  category?: string | null;
}

export const leadGenFeedbackApi = {
  list: (generatorId: string) =>
    api.get<LeadGenFeedbackNoteDto[]>(`/lead-generators/${generatorId}/feedback`),
  post: (generatorId: string, body: PostLeadGenFeedbackRequest) =>
    api.post<LeadGenFeedbackNoteDto>(`/lead-generators/${generatorId}/feedback`, body),
};
